export interface AgencyProfile {
  name: string;
  status: string;
  crm: string;
  clientsConnected: string;
  lastSync: string;
}

export interface ClientWorkspace {
  id: string;
  name: string;
  vertical: 'Real Estate' | 'Medspa';
  status: 'Connected' | 'Syncing' | 'Needs Connection';
  lastSync?: string;
}

export interface PilotChecklist {
  clientConnected: boolean;
  revenueAtRiskSurfaced: boolean;
  actionsSharedWithClient: boolean;
  weeklyInsightsEnabled: boolean;
}

export const mockAgencyProfile: AgencyProfile = {
  name: 'Example Agency',
  status: 'Pilot',
  crm: 'HubSpot',
  clientsConnected: '1',
  lastSync: 'Just now',
};

export const mockClientWorkspaces: ClientWorkspace[] = [
  {
    id: '1',
    name: 'ABC Realty',
    vertical: 'Real Estate',
    status: 'Connected',
    lastSync: '2 hours ago',
  },
  {
    id: '2',
    name: 'XYZ Medspa',
    vertical: 'Medspa',
    status: 'Syncing',
    lastSync: '5 minutes ago',
  },
  {
    id: '3',
    name: 'Metro Properties',
    vertical: 'Real Estate',
    status: 'Needs Connection',
  },
];

export const mockPilotChecklist: PilotChecklist = {
  clientConnected: true,
  revenueAtRiskSurfaced: true,
  actionsSharedWithClient: false,
  weeklyInsightsEnabled: false,
};
